import React from 'react';

const DownloadsTab = ({ downloads }) => (
  <div className="data-table">
    <h2 className="section-heading">Recent Downloads</h2>
    <table>
      <thead>
        <tr>
          <th>Email</th>
          <th>Downloaded At</th>
          <th>Download Count</th>
        </tr>
      </thead>
      <tbody>
        {downloads.map((download) => (
          <tr key={download.id}>
            <td>{download.email}</td>
            <td>{new Date(download.downloaded_at).toLocaleString()}</td>
            <td>{download.download_count}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default DownloadsTab;
